module.exports = __webpack_public_path__ + "static/assets/eac93f41670096e94b9ed9f719706a26.png";